import OneSignal from 'onesignal-cordova-plugin';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {
  private platform: Platform = inject(Platform);
  private router: Router = inject(Router);

  async register(idUser: string) {
    if (this.platform.is('mobile') && idUser) {
      // Inicializar OneSignal
      OneSignal.initialize(environment.onesignal.appId);

      // Configurar el manejador de clics en notificaciones
      this.setupNotificationClickHandler();

      // Solicitar permisos
      const permission = await OneSignal.Notifications.requestPermission(true);

      if (permission) {
        // Registrar usuario
        OneSignal.login(idUser);
        OneSignal.User.addTags({ id: idUser });
        this.setupNotificationClickHandler();
      }
    }
  }

  async unregister() {
    if (this.platform.is('mobile')) {
      OneSignal.logout();
    }
  }

  private setupNotificationClickHandler() {
    // Manejar clics en notificaciones
    OneSignal.Notifications.addEventListener('click', async (event) => {
      console.log('Notificación clickeada:', event);

      // Extraer datos adicionales
      const url = (event.notification as { url?: string }).url;

      // Redirigir basado en los datos
      await this.handleNotificationNavigation(url);
    });
  }

  private async handleNotificationNavigation(url: string | undefined) {
    try {
      // Si no hay URL, redirigir a home por defecto
      if (!url) {
        await this.router.navigate(['/tabs/home']);
        return;
      }

      // Buscar palabras clave en la URL
      const home = url.includes('home');
      const deals = url.includes('deals');
      const session = url.includes('ticket');
      const search = url.includes('search');
      const account = url.includes('account');

      if (home) {
        console.log('open home');
        await this.router.navigate(['/tabs/home']);
        return;
      }

      if (search) {
        console.log('open search');
        await this.router.navigate(['/tabs/search']);
        return;
      }

      if (deals) {
        console.log('open deals');
        await this.router.navigate(['/tabs/deals']);
        return;
      }

      if (session) {
        console.log('open session');
        await this.router.navigate(['/tabs/session']);
        return;
      }

      if (account) {
        console.log('open account');
        await this.router.navigate(['/tabs/account']);
        return;
      }

      // Si no coincide con ninguna palabra clave, redirigir a home
      await this.router.navigate(['/tabs/home']);
    } catch (error) {
      console.error('Error al navegar desde notificación:', error);
      await this.router.navigate(['/tabs/home']);
    }
  }
}
